module.exports = __webpack_public_path__ + "img/9_8.3501cd98.png";